import { Skeleton } from '@progress/kendo-react-indicators';

const LoadingCell = () => {
  return (
    <td>
      {' '}
      <Skeleton shape={'text'} style={{ width: '100%' }} />
    </td>
  );
};

export default LoadingCell;
